/**
 * 🎨 Enum representing all the possible bot durationsavailable for the bot stats
 */
export enum BotDuration {
  Week = 7 * (24 * 3600),
  TwoWeeks = 14 * (24 * 3600),
  Month = 30 * (24 * 3600),
  ThreeMonths = 90 * (24 * 3600),
  All = -1,
}

/**
 * 🔨 Converts a string to BotDuration object
 */
export function toBotDuration(durationAsString?: any): number {
  switch (durationAsString) {
    case "week": return BotDuration.Week;
    case "2 weeks": return BotDuration.TwoWeeks;
    case "month": return BotDuration.Month;
    case "3 months": return BotDuration.ThreeMonths;
    default: return BotDuration.All;
  }
}

/**
 * 🔨 Converts a BotDuration object to a string
 */
export function toBotDurationString(duration: BotDuration | null) {
  switch (duration) {
    case BotDuration.Week: return "week";
    case BotDuration.TwoWeeks: return "2 weeks";
    case BotDuration.Month: return "month";
    case BotDuration.ThreeMonths: return "3 months";
    case BotDuration.All: return "all";
    default: return "all";
  }
}